class VideoList extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.videoListType = this.getAttribute('data-video-list-type');
    this.videoItems = this.videoListType == 'thumbnails' ? this.querySelectorAll('.video-thumbnail') : this.querySelectorAll('.video-list__item');
    this.videoPopup = document.querySelector(`.type--${this.sectionId} .video-popup`);        
    this.popupVideos = this.videoPopup?.querySelectorAll('video');
    this.previewVideos = this.querySelectorAll('.video-list__item video');    
    this.videoControls = this.videoPopup?.querySelectorAll('.video-control');
    this.volumeControls = this.videoPopup?.querySelectorAll('.control__volume');
    this.addButton = this.videoPopup?.querySelectorAll('.video-quick-add__submit');
    this.controlProductBox = this.videoPopup?.querySelector('.control__product-box');
    this.productBoxes = this.videoPopup?.querySelectorAll('.video-product-box');
    this.productBoxesDetails = this.videoPopup?.querySelectorAll('.video-product-box__details');
    this.videoOverlayBottom = this.videoPopup?.querySelector('.video-overlay__bottom');
    this.productControl = this.videoPopup?.querySelector('.video-overlay__product');
    this.closeButtons = this.videoPopup?.querySelectorAll('.video-overlay__close');
    
    this.videoProductModals = this.videoPopup?.querySelectorAll('.video-product-modal');
    this.productModalClose = this.videoPopup?.querySelectorAll('.video-product-modal__close');
         
    this.videoIndex;

    this.closeButtons?.forEach((button) => {
      button.addEventListener('click', this.handleCloseVideoPopup.bind(this));
    });

    this.videoControls?.forEach((control) => {
      control.addEventListener('click', this.handleControlClick.bind(this));
    });

    this.controlProductBox?.addEventListener('click', this.handleControlProductBox.bind(this));

    this.productBoxesDetails?.forEach((productBox) => {      
      productBox.addEventListener('click', this.handleProductModal.bind(this));
    });

    this.productModalClose?.forEach((item) => {      
      item.addEventListener('click', this.handleProductModal.bind(this));
      if (this.videoListType == 'grids') {
        item.addEventListener('click', this.handleProductModalClose.bind(this));
      }
    });
    this.addButton?.forEach((button) => {
      button.addEventListener('click', this.handleProductModal.bind(this));
    })
    this.videoItems?.forEach((item) => {
      item.addEventListener('click', this.handleVideoItemClick.bind(this));      
    });
  }

  connectedCallback() {   
    if (this._connected) return;
    this._connected = true;  

    this.initPopupVideos();
    if (this.previewVideos.length > 0) {
      this.initPreviewVideos();
    }

      const _thisHandleProductModalClose = this.handleProductModalClose.bind(this);
      const _thisHandleProductModal = this.handleProductModal.bind(this);
      const _thisVideoOverlayBottom = this.videoOverlayBottom;
      const _thisVideoPopup = this.videoPopup;
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('video-item')) {
          if (e.target.closest('video-list').dataset.videoListType == "grids") {
            _thisVideoOverlayBottom.classList.remove('open');
            _thisVideoPopup.querySelectorAll('.video-item').forEach(el => {
              el.classList.remove('product_info')
            });
            _thisHandleProductModalClose(e);
          } else {
            _thisHandleProductModal(e);
          }
        }
      });
  
  }

  disconnectedCallback() {
    if (this.videoListType == 'grids') {
      document.removeEventListener('click', this.handleProductModalClose.bind(this));
    }
  }

  initPreviewVideos() {
    this.initIntersectionObserver();
  }

  initPopupVideos() {    
    this.popupVideos?.forEach((video) => {
      let isVideoPlaying = false;
      video.addEventListener('play', (e) => {
        this.videoIndex = video.dataset.index;        
        isVideoPlaying = true;
        for (let i = 1; i <= this.videoItems.length; i++) {
          let videoProgressBarItem = this.videoPopup.querySelector(`.video-progress-bar__item-inner[data-index="${i}"]`);
          if (i != this.videoIndex && i < this.videoIndex) {
            videoProgressBarItem.classList.add('has-played');
            videoProgressBarItem.style.transform = `scaleX(1)`;
            videoProgressBarItem.style.transition = `none`;
          } else {
            videoProgressBarItem.classList.remove('has-played');
            videoProgressBarItem.style.transform = `scaleX(0)`;
            videoProgressBarItem.style.transition = `none`;
          }
        }
        this.videoPopup.querySelector(`.video-progress-bar__item-inner[data-index="${this.videoIndex}"]`).classList.add('is-playing');
        this.videoPopup.querySelector(`.control__volume[data-index="${this.videoIndex}"]`).classList.remove('hidden');
      });

      video.addEventListener('playing', (e) => {        
        isVideoPlaying = true;
        this.videoIndex = e.target.dataset.index;
        let volumeControl = this.videoPopup.querySelector(`.control__volume[data-index="${this.videoIndex}"]`);
        if (volumeControl) 
          volumeControl.addEventListener('click', function() {
            if (video.muted) {
              setTimeout(() => {
                video.muted = false;
                this.querySelector('.volume-on').classList.remove('hidden');
                this.querySelector('.volume-off').classList.add('hidden');
              }, 100);
            } else {
              setTimeout(() => {
                video.muted = true;
                this.querySelector('.volume-on').classList.add('hidden');
                this.querySelector('.volume-off').classList.remove('hidden');
              }, 100);
            }
          })
      });

      let lastUpdateTime = 0;
      video.addEventListener('timeupdate', (e) => {
        const now = Date.now(); 
        if (isVideoPlaying && now - lastUpdateTime > 1500) { 
          lastUpdateTime = now; 
          this.videoIndex = video.dataset.index;
          let currentTime = video.currentTime;
          let videoProgressBarItem = this.videoPopup.querySelector(`.video-progress-bar__item-inner[data-index="${this.videoIndex}"]`);
          let duration = video.dataset.duration / 1000;
          let progress = (currentTime / duration);
          videoProgressBarItem.style.transform = `scaleX(${progress})`;
          videoProgressBarItem.style.transition = `transform 0.75s ease-out`;
        }
      });

      video.addEventListener('pause', (e) => {
        isVideoPlaying = false;
      });

      video.addEventListener('ended', (e) => {
        this.videoIndex = video.dataset.index;
        isVideoPlaying = false;
        let videoProgressBarItem = this.videoPopup.querySelector(`.video-progress-bar__item-inner[data-index="${this.videoIndex}"]`);
        videoProgressBarItem.style.transition = `none`;
        videoProgressBarItem.style.transform = `scaleX(1)`;
        videoProgressBarItem.classList.add('has-played');
        videoProgressBarItem.classList.remove('is-playing');
        this.playNextVideo("next", parseInt(this.videoIndex) - 1);
      });
    });
  }

  hasAudio(video) {
    return (
      video.mozHasAudio ||
      Boolean(video.webkitAudioDecodedByteCount) ||
      Boolean(video.audioTracks?.length)
    );
  }

  handleCloseVideoPopup(e) {   
    if (this.videoListType == "thumbnails") {
      e.stopImmediatePropagation()
    }
    this.resetVideos();
    this.videoPopup?.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
    
    this.videoOverlayBottom?.classList.remove('open');
    this.videoPopup?.querySelectorAll('.video-item').forEach(el => {
      el.classList.remove('product_info')
    });

    document.querySelectorAll('video-list .video-item')?.forEach(element =>{
      element.classList.remove('active');
    })
    
  }

  handleVideoItemClick(e) {
    if (!e.target.classList.contains('active')) {
      this.videoIndex = e.target.dataset?.index ? e.target.dataset.index : e.target.closest('.video-item')?.dataset?.index;
  
      document.querySelectorAll('video-list .video-item')?.forEach(element =>{
        element.classList.remove('active');
      })
      
      e.target.closest('.video-item')?.classList.toggle('active');
      
      if (this.videoListType == "thumbnails") {
        e.stopImmediatePropagation()
      }
  
      this.videoPopup.classList.remove('hidden');
      if (window.innerWidth < 750) {
        document.body.classList.add('overflow-hidden');
      }
      
      let thumbnail = e.target.parentElement;
      this.videoIndex = thumbnail.dataset.index;
      let video = this.videoPopup.querySelector(`video[data-index="${this.videoIndex}"]`);
      
      let volumeControl = this.videoPopup.querySelector(`.control__volume[data-index="${this.videoIndex}"]`);    
      this.resetVideos();
      volumeControl?.classList.remove('hidden');
      video.parentElement.classList.remove('hidden');
      video.play();
  
      if (this.videoListType == 'grids') {
        this.videoIndex = e.target.dataset?.index ? e.target.dataset.index : e.target.closest('.video-item')?.dataset?.index;    
        this.productBoxes.forEach((box) => {
          box.classList.add('hidden');
        });
        let productBox = this.videoPopup.querySelector(`.video-product-box[data-index="${this.videoIndex}"]`);      
        productBox.classList.toggle('hidden');
  
        this.videoProductModals.forEach((modal) => {
          modal.classList.add('hidden');
          let videoProductModalContent = modal.querySelector('.video-product-modal__content');
          let videoProductModalPlaceholder = modal.querySelector('.video-product-modal__placeholder');
          videoProductModalContent.innerHTML = '';
          videoProductModalPlaceholder.classList.remove('hidden');
        });
  
        this.videoOverlayBottom?.classList.remove('open');
        this.videoPopup.querySelectorAll('.video-item').forEach(el => {
          el.classList.remove('product_info')
        });
      } 
    }
  }

  handleControlClick(e) {
    if (this.videoListType == "thumbnails") {
      e.stopImmediatePropagation()
    }     
    let control = e.target.closest('.video-control');    
    this.playNextVideo(control.dataset.type, control.dataset.index);
  }

  handleControlProductBox(e) {     
    if (this.videoListType == "thumbnails") {
      e.stopImmediatePropagation()
    } 
    this.controlProductBox.classList.toggle('open');    
    if (this.productBoxes.length == 1) {
      this.productBoxes[0].classList.toggle('hidden')
    }
    if (this.productBoxes.length > 1) {
      this.productBoxes.forEach((box, index) => {        
        if (index != parseInt(this.videoIndex) - 1) {
          box.classList.add('hidden');
        } else {
          box.classList.toggle('hidden');
        }
      });
    }
  }

  handleProductModal(e) {            
    if (this.videoListType == "thumbnails") {
      e.stopImmediatePropagation()
    }
    this.videoOverlayBottom?.classList.toggle('open');
    this.videoPopup.querySelectorAll('.video-item').forEach(el => {
      el.classList.toggle('product_info')
      if (this.videoOverlayBottom?.classList.contains('open')) {
        el.classList.add('product_info')
      } else {
        el.classList.remove('product_info')
      }
    })

    if (this.videoListType == 'grids') {
      let videoProductModal = this.videoProductModals[this.videoIndex - 1];
      let videoProductModalContent = videoProductModal.querySelector('.video-product-modal__content');
      let videoProductModalPlaceholder = videoProductModal.querySelector('.video-product-modal__placeholder');
      videoProductModal.classList.remove('hidden'); 
      // let productHasVariants = this.videoPopup.querySelector(`.video-product-box[data-index="${this.videoIndex}"]`)?.querySelector('.video-quick-add__submit[type="button"]')
      // if (productHasVariants) {
        let productUrl = videoProductModal.getAttribute('data-product-url');
        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            let productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs(productElement);
            this.removeDOMElements(productElement);
            this.setInnerHTML(videoProductModalContent, productElement.innerHTML);
            videoProductModalPlaceholder.classList.add('hidden'); 
            videoProductModalPlaceholder.innerHTML = '';
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.preventVariantURLSwitching(videoProductModalContent);
          })
      // }
    }
  }

  handleProductModalClose(e) {            
    let target = e.target.closest('.video-product-modal__close');
    let videoIndex = target?.getAttribute('data-index') || this.videoIndex;    
    let video = this.videoPopup.querySelector(`video[data-index="${videoIndex}"]`);
    video.play();

    let videoProductModal = this.videoPopup.querySelector(`.video-product-modal[data-index="${videoIndex}"]`);
    videoProductModal.classList.add('hidden');
  }

  resetVideos() {
    this.popupVideos?.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.parentElement.classList.add('hidden');
      this.videoIndex = video.dataset.index;
      let volumeControl = this.videoPopup.querySelector(`.control__volume[data-index="${this.videoIndex}"]`);
      let videoProgressBarItem = this.videoPopup.querySelector(`.video-progress-bar__item-inner[data-index="${this.videoIndex}"]`);
      volumeControl.classList.add('hidden');
      videoProgressBarItem.classList.remove('has-played');
      videoProgressBarItem.classList.remove('is-playing');
      videoProgressBarItem.style.transition = `none`;
    });
  }

  resetAndCloseVideos() {
    this.resetVideos();
    this.videoPopup?.classList.add('hidden');
    this.videoOverlayBottom?.classList.remove('open');
    this.videoPopup?.querySelectorAll('.video-item').forEach(el => {
      el.classList.remove('product_info')
    })
    document.querySelectorAll('video-list .video-item')?.forEach(element =>{
      element.classList.remove('active');
    })
      
  }

  async playNextVideo(type, videoIndex) {
    let nextVideoIndex;
    if (type === "next") {
      nextVideoIndex = (parseInt(videoIndex) + 1) > this.videoItems.length ? 1 : parseInt(videoIndex) + 1;
    }
    if (type === "prev") {
      nextVideoIndex = (parseInt(videoIndex) - 1) < 1 ? this.videoItems.length : parseInt(videoIndex) - 1;
    }
    let nextVideo = this.videoPopup.querySelector(`video[data-index="${nextVideoIndex}"]`);
    this.videoIndex = nextVideoIndex;
    if (nextVideo) {
      this.resetVideos();
      nextVideo.parentElement.classList.remove('hidden');
      try {
        await nextVideo.play(); 
      } catch (error) {
        console.error('Error playing the next video:', error);
      }
    } else {
      this.resetVideos();
    }

    let currentVideoPreview = document.querySelector(`video-list .video-item[data-index="${videoIndex}"]`);
    let nextVideoPreview = document.querySelector(`video-list .video-item[data-index="${nextVideoIndex}"]`);

    currentVideoPreview?.classList.remove('active');
    nextVideoPreview?.classList.add('active');

    if (this.videoListType == 'grids') {
      this.videoPopup.querySelector(`.video-product-box[data-index="${videoIndex}"]`).classList.add('hidden');
      if (type === "next") {
        this.videoIndex = (parseInt(videoIndex) + 1) > this.videoItems.length ? 1 : parseInt(videoIndex) + 1;
      }
      if (type === "prev") {
        this.videoIndex = (parseInt(videoIndex) - 1) < 1 ? this.videoItems.length : parseInt(videoIndex) - 1;
      }    
      this.videoPopup.querySelector(`.video-product-box[data-index="${this.videoIndex}"]`).classList.remove('hidden');

      this.videoProductModals.forEach((modal) => {
        modal.classList.add('hidden');
        let videoProductModalContent = modal.querySelector('.video-product-modal__content');
        videoProductModalContent.innerHTML = '';
        let videoProductModalPlaceholder = modal.querySelector('.video-product-modal__placeholder');
        videoProductModalPlaceholder.classList.remove('hidden');
      });
    }
  }

    setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventVariantURLSwitching(videoProductModalContent) {
    videoProductModalContent.querySelector('variant-radios,variant-selects')?.setAttribute('data-update-url', 'false');
  }

  removeDOMElements(productElement) {
    const pickupAvailability = productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = productElement.querySelector('product-modal');
    if (productModal) productModal.remove();
  }

  preventDuplicatedIDs(productElement) {
    const sectionId = productElement.dataset.section;    
    productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
    productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
    });
  }

  initIntersectionObserver() {
    const observerOptions = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.1
    };

    let previewVideos = this.previewVideos;
    let thumbnailPlayingIndex;
    let previewOn = false;
    let eventListeners = new Map(); 

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          thumbnailPlayingIndex = thumbnailPlayingIndex ? thumbnailPlayingIndex : 0;
          previewOn = true;
          const currentVideo = previewVideos[thumbnailPlayingIndex];
          currentVideo.play();
          previewVideos.forEach((video, index) => {
            const playListener = () => {
              setTimeout(() => {
                thumbnailPlayingIndex = (thumbnailPlayingIndex + 1) < previewVideos.length ? thumbnailPlayingIndex + 1 : 0;
                playNextPreviewVideo(thumbnailPlayingIndex);
              }, 5000);
            };
            eventListeners.set(video, playListener);
            video.addEventListener('play', playListener);
          });
        } else {
          previewOn = false;
          thumbnailPlayingIndex = 0;
          previewVideos.forEach(video => {
            video.pause();
            video.currentTime = 0;
            const playListener = eventListeners.get(video);
            if (playListener) {
              video.removeEventListener('play', playListener);
              eventListeners.delete(video);
            }
          });
        }
      });
    };

    function playNextPreviewVideo() {
      if (!previewOn) return;
      let previousIndex = thumbnailPlayingIndex == 0 ? previewVideos.length - 1 : thumbnailPlayingIndex - 1;
      const previousVideo = previewVideos[previousIndex];
      previousVideo.pause();
      previousVideo.currentTime = 0;
      const currentVideo = previewVideos[thumbnailPlayingIndex];
      currentVideo.play();
    }

    this.observer = new IntersectionObserver(observerCallback, observerOptions);
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('video-list', VideoList);

class VideoPopup extends HTMLElement {
  constructor() {
   super();   
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  
}

customElements.define('video-popup', VideoPopup);

document.addEventListener('click', function(e) {
  // close video popup when click outside of the video popup
  let closestVideoItem = e.target.closest('.video-list__item');
  let closestVideoPopup = e.target.closest('.video-popup');
  if (!closestVideoItem && !closestVideoPopup) {    
    document.querySelectorAll('video-list')?.forEach((videoList) => {
      videoList.resetAndCloseVideos();
    });
  }  
})
